import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTeam } from '../api/fetchExampleData'; // Usa la tua query hook
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import Wrapper from '../components/Wrapper/Wrapper';
import SEO from '../components/SEO/SEO';

// Styled Components
const TeamSection = styled.div`
  margin-top: 2em;

    @media (max-width: 768px) {
    margin-top: 0.5em;
  }

  h2 {
    margin: 0 0 2em;
    font-size: 2rem;
    font-weight: bold;

    @media (max-width: 768px) {
      margin: 0 0 1.5em;
      text-align: center;
  }
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Forza 3 colonne */
  gap: 2em; /* Spaziatura tra le card */
  margin-bottom: 3em;

  @media (max-width: 768px) {
    margin-bottom: 2em;
    gap: 1.5em;
    grid-template-columns: repeat(2, 1fr); /* Mantieni 2 colonne su schermi piccoli */
  }
`;

const TeamCard = styled(Link)`
  text-decoration: none !important;
  color: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    text-align: center;
  }

  img {
    border-radius: 50%;
    width: 200px;
    height: 200px;
    @media (max-width: 768px) {
      width: 120px;
      height: 120px;
    }
  }

  h2 {
    margin: 0.5em 0 0;
    font-size: 2rem;
    text-align: center;

  @media (max-width: 768px) {
    margin: 0em 1em;
    margin-top: 0.5em;
    font-size: 1.2rem;
    white-space: pre-wrap; /* Permette il wrap sugli spazi */
    word-break: break-word; /* Rompe la parola se necessario */
  }
  }

  p {
    margin: 0;
    font-size: 1rem;
    color: #666;
  }
`;

const TeamPage = () => {
  // Usa la query React Query per recuperare i dati del team
  const { data: response } = useTeam();
  const team = response?.data;
  const meta = response?.meta;

  // Filtra i membri del team in base ai ruoli
  const administration = team
  ?.filter((member) => member.roles.includes('administrator') && member.id !== 12 && member.id !== 56) || [];
  const editors = team?.filter((member) => member.roles.includes('editor')) || [];
  const contributors = team?.filter((member) => member.roles.includes('contributor')) || [];
  const adminEditor = [...administration, ...editors];

  const renderTeamMembers = (members) => (
    <GridContainer>
      {members.map((member) => (
        <TeamCard
          to={`/team/${member.name.replace(/\s+/g, '-').toLowerCase()}`}
          key={member.id}
        >
          <img src={member.avatar} alt={`${member.name}'s avatar`} />
          <h2>{member.name}</h2>
        </TeamCard>
      ))}
    </GridContainer>
  );

  return (
    <>
      <SEO
        title="Team di Rossomotori.it"
        description="Il team di Rossomotori.it"
        url="https://rossomotori.it/team"
      />
      <Breadcrumb />
      <TeamSection>
        <h2>REDAZIONE</h2>
        {renderTeamMembers(adminEditor, 'Ruolo amministrativo')}
        <h2>SOCIAL MEDIA</h2>
        {renderTeamMembers(contributors, 'Ruolo redazionale')}
      </TeamSection>
    </>
  );
};

export default TeamPage;
